export interface SkeletonProps {
  className?: string;
}

/**
 * Animated skeleton placeholder. Matches the shape of the content it replaces.
 * Uses animate-pulse per frontend-ui-system.md.
 */
export function Skeleton({ className = 'h-4 w-full' }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded bg-[var(--surface2)] ${className}`}
      aria-hidden="true"
    />
  );
}
